/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Day_Plan_LabelInputs */

const en_features_day_plan_label = /** @type {(inputs: Features_Day_Plan_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's plan`)
};

const pl_features_day_plan_label = /** @type {(inputs: Features_Day_Plan_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan na dziś`)
};

/**
* | output |
* | --- |
* | "Today's plan" |
*
* @param {Features_Day_Plan_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_plan_label = /** @type {((inputs?: Features_Day_Plan_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_Plan_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_plan_label(inputs)
	return en_features_day_plan_label(inputs)
});